import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'

import DatePicker from 'material-ui/DatePicker'
import TextField from 'material-ui/TextField'

import { getTimezoneDate } from 'utils/date'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import InputMoney from 'components/InputMoney'
import {getMonth} from 'utils/date'
import PropertyCombobox from './PropertyCombobox'


let select = dirtyRead(
	(state, props) => ({
		listing: doc(state, props.objectID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<PropertyCombobox objectID={props.objectID}/>
					<div style={{margin: "0px", display:"inline-block", width: "40px"}}>
						<img
							src="/static/img/calendar-green.png"
							style={{
							  width: "20px"
							, position: "relative"
							, top: "3px"
							}}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						List date</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: props.listing.dateFrom ? "0px solid" : "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.listing.dateFrom)?getTimezoneDate(props.listing.dateFrom):""}
							onChange={(evt, value)=>
								props.STAGE({
									_id: props.objectID
									, dateFrom: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
								})
							}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Unlist date</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: props.listing.dateTill ? "0px solid" : "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.listing.dateTill)?getTimezoneDate(props.listing.dateTill):""}
							onChange={(evt, value)=>
								props.STAGE({
									_id: props.objectID
									, dateTill: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
								})
							}
						/>
					</div>

					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Rent"
							defaultValue={props.listing.rent}
							style={{
								width: "100%",
								marginTop: "-10px"
							}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.listing.rent}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , rent: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Security deposit"
							defaultValue={props.listing && props.listing.securityDeposit}
							style={{
								width: "100%",
								marginTop: "-10px"
							}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.listing && props.listing.securityDeposit}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , securityDeposit: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Pet Deposit"
							defaultValue={props.listing && props.listing.petDeposit}
							style={{
								width: "100%",
								marginTop: "-10px"
							}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.listing && props.listing.petDeposit}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , petDeposit: evt.target.value
								})
							}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40px"}}>
						<img
							src="/static/img/calendar-green.png"
							style={{
							  width: "20px"
							, position: "relative"
							, top: "3px"
							}}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "50%"}}>
						<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Available from</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: props.listing.availableFrom ? "0px solid" : "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.listing.availableFrom)?getTimezoneDate(props.listing.availableFrom):""}
							onChange={(evt, value)=>
								props.STAGE({
									_id: props.objectID
									, availableFrom: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
								})
							}
						/>
					</div>
				{	/*<div style={{margin: "0px", display:"inline-block", width: "40px"}}>
						<img
							src="/static/img/calendar-green.png"
							style={{
							  width: "20px"
							, position: "relative"
							, top: "3px"
							}}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>

					</div>*/}
				</div>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/listingForm/LeftSide.js